import { RouterLink } from "@angular/router";

export const MENU_ADMIN = [
    {
        label: 'Modulos',
        items: [
            {
                label: 'Pagina de inicio',
                routerLink: ['/administrador']

            },
            {
                label: 'Log de Sistema',
                routerLink: ['/administrador/logsis']

            },
            {
                label: 'Medicos',
                routerLink: ['/administrador/medicos']

            },
            {
                label: 'Enfermeras',
                routerLink: ['/administrador/enfermeras']

            },
            {
                label: 'Supervisores',
                routerLink: ['/administrador/supervisores']

            },
            {
                label: 'Casos Clinicos',
                routerLink: ['/administrador/casosclinicos']
            },
            {
                label: 'Catalogos',
                items: [
                    {
                        label: 'Diagnosticos',
                        items: [
                            {
                                label: 'Lista de diagnosticos',
                                routerLink: ['/administrador/diagnosticos']
                            },
                            {
                                label: 'Nuevo de diagnostico',
                                icon: 'pi pi-fw pi-plus',
                                routerLink: ['/administrador/diagnostico/nuevo']
                            }

                        ]
                    },
                    {
                        label: 'Antibioticos',
                        items: [
                            {
                                label: 'Lista de antibioticos',
                                routerLink: ['/administrador/antibioticos']
                            },
                            {
                                label: 'Nuevo de antibiotico',
                                icon: 'pi pi-fw pi-plus',
                                routerLink: ['/administrador/antibiotico/nuevo']
                            }

                        ]
                    },
                    {
                        label: 'Puntos',
                        items: [
                            {
                                label: 'Lista de puntos',
                                routerLink: ['/administrador/puntos']
                            },
                            {
                                label: 'Nuevos de puntos',
                                icon: 'pi pi-fw pi-plus',
                                routerLink: ['/administrador/puntos/nuevo']
                            }

                        ]
                    }
                ],

            },
            {
                label: 'Informes',
                items: [
                    {
                        label: 'Saldo General',
                        items: [
                            {
                                label: 'Medicos',
                                routerLink: ['/administrador/saldogeneral/medicos']
                            },
                            {
                                label: 'Enfermeras',
                                routerLink: ['/administrador/saldogeneral/enfermeras']
                            },
                        ]

                    },
                    {
                        label: 'Informe Canjes',
                        items: [
                            {
                                label: 'Medicos',
                                routerLink: ['/administrador/informe/canjes/medicos']
                            }
                        ]

                    }


                ]
            },
            {
                label: 'Productos',
                items: [
                    {
                        label: 'Lista de productos',
                        routerLink: ['/administrador/productos']
                    },
                    {
                        label: 'Subir batch',
                        routerLink: ['/administrador/productos/batch']
                    }
                ]

            },
            {
                label: 'Hospitales',
                items: [
                    {
                        label: 'Lista de Hospitales',
                        routerLink: ['/administrador/hospitales']
                    },
                    {
                        label: 'Nuevo Hospital',
                        icon: 'pi pi-fw pi-plus',
                        routerLink: ['/administrador/hospital/nuevo']
                    }
                ]

            },
            {
                label: 'Instituciones',
                items: [
                    {
                        label: 'Lista de Instituciones',
                        routerLink: ['/administrador/instituciones']
                    },
                    {
                        label: 'Nueva Institucion',
                        icon: 'pi pi-fw pi-plus',
                        routerLink: ['/administrador/institucion/nuevo']
                    }
                ]

            },
            {
                label: 'Usuarios',
                items: [
                    {
                        label: 'Lista de Usuarios',
                        routerLink: ['/administrador/usuarios']
                    },
                    {
                        label: 'Nuevo Usuario',
                        icon: 'pi pi-fw pi-plus',
                        routerLink: ['/administrador/usuario/nuevo']
                    }

                ]

            }
        ]
    }
];
export const MENU_ADMIN_N1 = [
    {
        label: 'Modulos',
        items: [
            {
                label: 'Pagina de inicio',
                routerLink: ['/administrador']

            },
            {
                label: 'Medicos',
                routerLink: ['/administrador/medicos']

            },
            {
                label: 'Enfermeras',
                routerLink: ['/administrador/enfermeras']

            },
            {
                label: 'Supervisores',
                routerLink: ['/administrador/supervisores']

            },
            {
                label: 'Casos Clinicos',
                routerLink: ['/administrador/casosclinicos']
            },
            {
                label: 'Catalogos',
                items: [
                    {
                        label: 'Diagnosticos',
                        items: [
                            {
                                label: 'Lista de diagnosticos',
                                routerLink: ['/administrador/diagnosticos']
                            },
                            {
                                label: 'Nuevo de diagnostico',
                                icon: 'pi pi-fw pi-plus',
                                routerLink: ['/administrador/diagnostico/nuevo']
                            }

                        ]
                    },
                    {
                        label: 'Antibioticos',
                        items: [
                            {
                                label: 'Lista de antibioticos',
                                routerLink: ['/administrador/antibioticos']
                            },
                            {
                                label: 'Nuevo de antibiotico',
                                icon: 'pi pi-fw pi-plus',
                                routerLink: ['/administrador/antibiotico/nuevo']
                            }

                        ]
                    },
                    {
                        label: 'Puntos',
                        items: [
                            {
                                label: 'Lista de puntos',
                                routerLink: ['/administrador/puntos']
                            },
                            {
                                label: 'Nuevos de puntos',
                                icon: 'pi pi-fw pi-plus',
                                routerLink: ['/administrador/puntos/nuevo']
                            }

                        ]
                    }
                ],

            },
            {
                label: 'Informes',
                items: [
                    {
                        label: 'Saldo General',
                        items: [
                            {
                                label: 'Medicos',
                                routerLink: ['/administrador/saldogeneral/medicos']
                            },
                            {
                                label: 'Enfermeras',
                                routerLink: ['/administrador/saldogeneral/enfermeras']
                            },
                        ]

                    }


                ]
            },
            {
                label: 'Hospitales',
                items: [
                    {
                        label: 'Lista de Hospitales',
                        routerLink: ['/administrador/hospitales']
                    },
                    {
                        label: 'Nuevo Hospital',
                        icon: 'pi pi-fw pi-plus',
                        routerLink: ['/administrador/hospital/nuevo']
                    }
                ]

            },
            {
                label: 'Instituciones',
                items: [
                    {
                        label: 'Lista de Instituciones',
                        routerLink: ['/administrador/instituciones']
                    },
                    {
                        label: 'Nueva Institucion',
                        icon: 'pi pi-fw pi-plus',
                        routerLink: ['/administrador/institucion/nuevo']
                    }
                ]

            },
        ]
    }
];

export const MENU_ADMIN_N2 = [
    {
        label: 'Modulos',
        items: [
            {
                label: 'Pagina de inicio',
                routerLink: ['/administrador']

            },
            {
                label: 'Productos',
                items: [
                    {
                        label: 'Lista de productos',
                        routerLink: ['/administrador/productos']
                    },
                    {
                        label: 'Subir batch',
                        routerLink: ['/administrador/productos/batch']
                    }
                ]

            }
        ]
    }
];

export const MENU_MEDICO = [
    {
        label: 'Modulos',
        items: [
            {
                label: 'Casos Clinicos',
                routerLink: ['/medico/casosclinicos']
            },
            {
                label: 'Productos',
                routerLink: ['/medico/productos']

            },
            {
                label: 'Saldo',
                routerLink: ['/medico/saldo']

            },
            {
                label: 'Canjes',
                items: [
                    {
                        label: 'Informe canjes',
                        routerLink: ['/medico/canjes']
                    },
                    {
                        label: 'Solicitud de Canje',
                        icon: 'pi pi-fw pi-plus',
                        routerLink: ['/medico/solicitud/canje']
                    }
                ]

            },
        ]
    }
];

export const MENU_ENFERMERA = [
    {
        label: 'Modulos',
        items: [
            {
                label: 'Casos Clinicos',
                items: [
                    {
                        label: 'Lista de Casos Clinicos',
                        routerLink: ['/enfermera/casosclinicos']
                    }
                ]

            },
            {
                label: 'Saldo',
                routerLink: ['/enfermera/saldo']

            },
            {
                label: 'Canjes',
                items: [
                    {
                        label: 'Informe canjes',
                        routerLink: ['/enfermera/canjes']
                    },
                    {
                        label: 'Solicitud de Canje',
                        icon: 'pi pi-fw pi-plus',
                        routerLink: ['/enfermera/solicitud/canje']
                    }
                ]

            },
        ]
    }
];

export const MENU_SUPERVISOR = [
    {
        label: 'Modulos',
        items: [
            {
                label: 'Casos Clinicos',
                routerLink: ['/supervisor/casosclinicos']

            },
            {
                label: 'Enfermeras',
                routerLink: ['/supervisor/enfermeras']

            },
            {
                label: 'Pendientes por asignar',
                routerLink: ['/supervisor/pendientes']

            },
            {
                label: 'Canjes',
                items: [
                    {
                        label: 'Informe canjes',
                        routerLink: ['/supervisor/canjes']
                    },
                    {
                        label: 'Solicitud de Canje',
                        icon: 'pi pi-fw pi-plus',
                        routerLink: ['/supervisor/solicitud/canje']
                    }
                ]

            },
            {
                label: 'Catalogos',
                items: [
                    {
                        label: 'Hospitales',
                        items: [
                            {
                                label: 'Lista de Hospitales',
                                routerLink: ['/supervisor/hospitales']
                            },
                            {
                                label: 'Nuevo Hospital',
                                icon: 'pi pi-fw pi-plus',
                                routerLink: ['/supervisor/hospital/nuevo']
                            }
                        ]

                    },
                    {
                        label: 'Instituciones',
                        items: [
                            {
                                label: 'Lista de Instituciones',
                                routerLink: ['/supervisor/instituciones']
                            },
                            {
                                label: 'Nueva Institucion',
                                icon: 'pi pi-fw pi-plus',
                                routerLink: ['/supervisor/institucion/nuevo']
                            }
                        ]

                    },
                ],

            },

        ]
    }
];